import { Dialog } from '@mui/material';
import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { UpdateMerchantDocument } from 'store/actions/complianceActions';

export default function PolicyApprovalDialog({ document, mode, isOpen, setIsOpen, handleCallback }) {
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();

    function handleClose() {
        setIsOpen(false);
    }

    async function updateDocumentStatus() {
        try {
            setIsLoading(true);

            const nativeFormData = {
                approved_status: mode === 'approve' ? 'approved' : 'declined',
            };

            const response = await dispatch(UpdateMerchantDocument(nativeFormData, document?.id, document?.tag));
            if (!response.success) throw new Error(response?.message);

            toast.success(mode === 'approve' ? 'Document approved successfully' : 'Document declined successfully');
            handleClose();
            handleCallback();
        } catch (error) {
            toast.error(
                error?.message || mode === 'approve' ? 'Failed to approve document' : 'Failed to reject document'
            );
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            PaperProps={{
                sx: {
                    borderRadius: '4px !important',
                    padding: 0,
                    boxShadow: '0px 16px 24px 0px #00000026',
                    width: '440px',
                },
            }}
        >
            <div className="!p-6 flex flex-col !gap-2 justify-center items-center">
                <h5 className="text-lg font-semibold text-[#475569]">
                    {mode === 'approve' ? 'Approve' : 'Reject'} policy?
                </h5>

                <p className="text-center text-[#64748B] text-[13px]">
                    By {mode === 'approve' ? 'approving' : 'rejecting'} this policy, all employees may be notified of
                    the new policy update
                </p>
            </div>

            <div className="flex items-center justify-center !p-6 bg-[#F8FAFC] !gap-2">
                <button
                    className="bg-[#fff] !border !border-[#E2E8F0] !rounded-sm !px-4 !py-2 hover:brightness-90 transition-all text-[#334155] text-sm font-medium"
                    onClick={handleClose}
                >
                    Cancel
                </button>

                <button
                    className={
                        mode === 'approve'
                            ? 'bg-[#395BA9] !rounded-sm !px-4 !py-2 hover:brightness-90 transition-all text-white text-sm font-medium disabled:opacity-50 disabled:pointer-events-none flex items-center !gap-1'
                            : 'bg-[#FF5449] !rounded-sm !px-4 !py-2 hover:bg-[#151e44] transition-all hover:brightness-95 text-white text-sm font-semibold disabled:opacity-50 disabled:pointer-events-none flex items-center !gap-1'
                    }
                    disabled={isLoading}
                    onClick={updateDocumentStatus}
                >
                    {isLoading && <Loader2 className="!h-5 !w-5 animate-spin" />} Yes,{' '}
                    {mode === 'approve' ? 'approve' : 'reject'}
                </button>
            </div>
        </Dialog>
    );
}
